import React from 'react';
import { AlertTriangle } from 'lucide-react';

// "Actively exploited" marker for techniques tied to a CISA KEV CVE — oxblood
// (threat) per the brand (ADR-6). Uses the prototype .tv-kev-tag pill.
const KevBadge = ({ compact = false }) => (
  <span
    className="tv-kev-tag"
    title="Actively exploited — listed in the CISA KEV catalogue"
  >
    <AlertTriangle style={{ width: 11, height: 11 }} />
    {!compact && 'KEV'}
  </span>
);

export default KevBadge;
